// extracted by mini-css-extract-plugin
export var modal = "modal-questionnaire-module--modal--13e5b";
export var thankyou = "modal-questionnaire-module--thankyou--8f699";
export var widget = "modal-questionnaire-module--widget--1e45e";